module.exports = __webpack_public_path__ + "static/media/whrep_logo.b2f75982.png";